export interface PersonOption {
  value: string;
  label: string;
}

const personOptionsCache = new Map<number, PersonOption[]>();

/**
 * Reads cached person dropdown options for a company.
 */
export const getCachedPersonOptions = (
  companyId: number,
): PersonOption[] | undefined => {
  return personOptionsCache.get(companyId);
};

/**
 * Stores person dropdown options in cache for a company.
 */
export const setCachedPersonOptions = (
  companyId: number,
  options: PersonOption[],
): void => {
  personOptionsCache.set(companyId, options);
};

/**
 * Clears cached filter options for a company.
 */
export const invalidateCompanyFilterOptionsCache = (
  companyId: number,
): void => {
  personOptionsCache.delete(companyId);
};
